/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Miniheader } from "./Miniheader";
import location from "../Images/Icones/Location.svg";
import SepLoc from "../Images/Icones/SepLoc.svg";
import iconoir from "../Images/Icones/iconoir.svg";
import discount from "../Images/Icones/Discount.svg";
import arrowdown from "../Images/Icones/ArrowDown.svg";
import profilicon from "../Images/Icones/profificon.svg";
import searchicon from "../Images/Icones/searchicon.svg";
import buyicon from "../Images/Icones/buyicon.svg";
import logoAb from "../Images/Logos/logo-white.png";
import MenuIcon from '@mui/icons-material/Menu';
import "./Styles/header.css"
import Cookies from 'universal-cookie';
import InfoIcon from '@mui/icons-material/Info';
import ListAltIcon from '@mui/icons-material/ListAlt';
import FavoriteIcon from '@mui/icons-material/Favorite';
import LogoutIcon from '@mui/icons-material/Logout';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import StorefrontIcon from '@mui/icons-material/Storefront';
import FacebookIcon from '@mui/icons-material/Facebook';
import { Instagram, LinkedIn } from "@mui/icons-material";

export const Header = ({ changeShowCateState = null }) => {

    const [user, setUser] = useState(null);
    const [search, setSearch] = useState('');
    const [isSubMenu, setIsSubMenu] = useState(false);
    const isLoad = true;
    const cookies = new Cookies();
    
    useEffect(() => {
        if (cookies.get('user')) {
            setUser(cookies.get('user'));
        }

        const queryParameters = new URLSearchParams(window.location.search)

        if (queryParameters.get("search") !== null) {
            setSearch(queryParameters.get("search"))
        }
    }, [isLoad])

    const goToCart = () => {
        window.location.href = '/panier'
    }
    const [goFixed, setFixed] = useState(false);
    const [lastScrollTop, setLastScrollTop] = useState(0);


    useEffect(() => {
        const handleScroll = () => {
            const currentScroll = window.pageYOffset;
            if (currentScroll > lastScrollTop) {
                if (currentScroll >= 145) {
                    setFixed(true);
                }
            } else if (currentScroll <= 140) {
                setFixed(false);
            }
            setLastScrollTop(currentScroll <= 0 ? 0 : currentScroll);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [lastScrollTop]);


    const goToLogin = () => {
        window.location.href = '/connexion'
    }

    const toggleSubMenu = () => {
        setIsSubMenu(isSubMenu ? false : true)
    }

    const handleSearch = () => {
        if (search !== '') {
            window.location.href = '/boutique?search=' + search
        }
    }

    const goToBeSeller = () => {
        window.location.href = '/devenir-vendeur'
    }

    return (
        <>
            <div style={window.innerWidth > 770 ? { display: "none" } : goFixed ? { height: "138px", background: "rgba(0, 0, 0, 0.45)", backdropFilter: "blur(6px)" } : { display: "none" }}></div>
            <header className={goFixed ? "flexcenter gofixed-header" : "flexcenter"}>
                <div className="flexcenter top-header top-blue-header">
                    <div className="leftheader flexcenter">
                        <a href="https://goo.gl/maps/DYrH3fjhn89dnm5SA" target="_blank"><Miniheader img={location} label="Dakar, Liberté 6 Extension" /></a>
                        <img src={SepLoc} alt="image2" />
                        <a className="tel-header" href="tel:+221 33 824 70 43"><Miniheader icon={true} img={LocalPhoneIcon} label="+221 33 824 70 43" /></a>
                        <a style={{ marginLeft: '10px', marginRight: '-18px' }} href="https://www.facebook.com/KabaashopShoppingonline/"><Miniheader icon={true} img={FacebookIcon} label="" /></a>
                        <a style={{ marginRight: '-18px' }} href="https://instagram.com/kabaashoponline?igshid=YmMyMTA2M2Y="><Miniheader icon={true} img={Instagram} label="" /></a>
                        <a href="https://www.linkedin.com/feed/update/urn:li:activity:7018879223645765632"><Miniheader icon={true} img={LinkedIn} label="" /></a>
                    </div>
                    <div>
                        <button onClick={() => { goToBeSeller() }} className="flexcenter langue">
                            <span style={{ display: 'flex' }}><StorefrontIcon sx={{ fontSize: '18px', marginRight: '5px' }} />Devenir Vendeur</span>
                        </button>
                    </div>
                </div>
                <div className="flexcenter bot-header">
                    <div className="hamburger" onClick={changeShowCateState}>
                        <MenuIcon sx={{ color: 'white' }} />
                    </div>
                    <a className="logo" href='/'><img src={logoAb} alt="logo" /></a>
                    <form action="#" onSubmit={(e) => {
              e.preventDefault();
              handleSearch();
            }}>
                    <div className="search">
                        
                            <img style={{ cursor: 'pointer' }} id="search-input-button" onClick={() => { handleSearch() }} src={searchicon} alt="search" />
                            <input required value={search} type="search" onChange={(e)=>{setSearch(e.target.value)}} placeholder="Airpods max, Nike, Frigo..." />
                       
                    </div>
                    </form>
                    <div className="flexcenter right-side">
                        {
                            user !== null ?
                                (
                                    <button onClick={() => { toggleSubMenu() }} className="flexcenter connect">
                                        <img src={profilicon} alt="search" />
                                        <span>{user.firstname}</span>
                                    </button>
                                ) :
                                (
                                    <button onClick={() => { goToLogin() }} className="flexcenter connect">
                                        <img src={profilicon} alt="search" />
                                        <span>Se connecter</span>
                                    </button>
                                )
                        }
                        <button onClick={() => { goToCart() }} className="flexcenter connect">
                            <img src={buyicon} alt="buyicon" />
                            <span>Panier</span>
                        </button>
                    </div>
                </div>
            </header>
            <div style={{ display: isSubMenu ? 'block' : 'none' }} className="user-sub-menu">
                <ul>
                    <li><a href="/profil"><span><InfoIcon sx={{ fontSize: "20px", margin: "0 -5px 0 10px" }} /></span> <span>Mon Profil</span></a></li>
                    <li><a href="/commandes"><span><ListAltIcon sx={{ fontSize: "20px", margin: "0 -5px 0 10px" }} /></span> <span>Mes Commandes</span></a></li>
                    <li><a href="/favoris"><span><FavoriteIcon sx={{ fontSize: "20px", margin: "0 -5px 0 10px" }} /></span> <span>Mes Favoris</span></a></li>
                    <li><a href="/deconnexion" ><span><LogoutIcon sx={{ fontSize: "20px", margin: "0 -5px 0 10px" }} /></span> <span>Déconnexion</span></a></li>
                </ul>
            </div>
        </>
    )
}